import React from "react";
import useSalesReceiptStore from "../store";

export default function AdditionalExpenses() {
  const { todaysCreditCardFees } = useSalesReceiptStore();

  // if (creditCardFees == undefined || creditCardFees == null || creditCardFees == {}) {
  //   return null;
  // }

  return (
    <div className="mx-3 my-3 border-white rounded shadow-sm p-3">
      <h4>Additional Expenses - Credit Card Fee</h4>
      <div className="row my-2">
        <div className="col-md-12 row">
          <div className="mb-3 col-md-6">
            <label htmlFor="fee-amount" className="form-label">
              Fee Amount:
            </label>
            <input
              id="fee-amount"
              name="fee-amount"
              type="text"
              className="form-control"
              value={todaysCreditCardFees?.amount || 0}
              readOnly // Make the input readonly if it's for display only
              disabled
            />
          </div>
          <div className="mb-3 col-md-6">
            <label htmlFor="sales-date" className="form-label">
              Sales Date:
            </label>
            <input
              id="sales-date"
              name="sales-date"
              type="text"
              className="form-control"
              value={todaysCreditCardFees?.sales_date}
              readOnly // Make the input readonly if it's for display only
              disabled
            />
          </div>
        </div>
      </div>
    </div>
  );
}
